<template>
  <div>
    <div class="topshopguide__list__item" v-if="!isLoadingChild">
      <router-link class="itemstatus__new" :to="'/shop-guide/' + itemShopguideChild.id">
        <!-- <div
          class="itemstatus__new__banner"
          v-if="diffDate(itemShopguideChild.acf?.start_date) <= 7"
        >
          <img src="@/assets/img/top/portal_icon.svg" alt="" />
          <div class="itemstatus__new__banner__text">
            NEW
          </div>
        </div> -->
        <div
          class="item__img"
          :style="{ backgroundImage: `url(${$func.formatUrl(itemShopguideChild.acf?.shop_image)})` }"
          v-if="itemShopguideChild.acf?.shop_image || itemShopguideChild.acf?.shop_name && itemShopguideChild.acf?.shop_image != '' || itemShopguideChild.acf?.shop_image != false"
        >
          <img :src="$func.formatUrl(itemShopguideChild.acf?.shop_image)" :alt="itemShopguideChild.acf?.shop_name" />
        </div>
        <div class="item__img" 
          :style="{ backgroundImage: `url(${(urlNowRinting.url)})` }"
          v-if="itemShopguideChild.acf?.shop_image === '' || itemShopguideChild.acf?.shop_image === false" > 
            <img :src="urlNowRinting.url" :alt="urlNowRinting.alt" /> 
        </div>
        <div class="item__text">
          <ul class="item__cate" v-if="itemShopguideChild.acf?.shop_type">
            <li :class="itemShopguideChild.acf?.shop_type === '飲食' ? '' : 'txt_b_custom'" v-if="itemShopguideChild.acf?.shop_type === '飲食' && itemShopguideChild.acf?.shop_type != null && itemShopguideChild.acf?.shop_type != ''">{{ itemShopguideChild.acf?.shop_type }}</li>
            <li :class="itemShopguideChild.acf?.shop_type === 'その他' ? 'txt_b_custom' : ''" v-if="itemShopguideChild.acf?.shop_type === 'その他' && itemShopguideChild.acf?.shop_type != null && itemShopguideChild.acf?.shop_type != ''">{{ itemShopguideChild.acf?.shop_type }}</li>
          </ul>
          <span class="item__title" v-if="itemShopguideChild.acf?.shop_name || itemShopguideChild.acf?.shop_id">{{ itemShopguideChild.acf?.shop_id + '.' + itemShopguideChild.acf?.shop_name }}</span>
          <span class="item__note" v-if="itemShopguideChild.acf?.shop_area || itemShopguideChild.acf?.shop_floor">{{ itemShopguideChild.acf?.shop_area + itemShopguideChild.acf?.shop_floor }}</span>
        </div>
      </router-link>
    </div>
    <div class="skeleton-parent" v-if="isLoadingChild">
      <PuSkeleton style="height: 300px;" :count="1"/>
    </div>
  </div>
</template>

<script>
import moment from "moment";
// import axios from "axios";
// import { Fragment } from "vue-fragment";
import { RouterLink } from "vue-router";
import CONSTANT from "../../constant.js";

export default {
  name: "ItemShopguide",
  props: {
    itemShopguideChild: {
      type: Object,
    },
    index: {
      type: Number
    },
    isLoadingChild: {
      type: Boolean
    }
  },
  data() {
    return {
      // shopGuideList: [],
      // isLoading: true,
      urlNowRinting: CONSTANT.dataImageNowrinting,
    };
  },
  components: {
    // Fragment,
  },
  computed: {},
  methods: {
    // diffDate(shopguide) {
    //   var start = moment(shopguide);
    //   var current = moment();
    //   return current.diff(start, 'days')
    // },
  },
  created() {
    // const shopGuideListlUrl =
    //   process.env.VUE_APP_BASE_URL +
    //   `/shop_guide?acf_format=standard&_fields=id,acf`;
    // this.isLoading = true;
    // axios
    //   .get(shopGuideListlUrl, {
    //     headers: {
    //       Authorization: `Basic ${process.env.VUE_APP_BASE_TOKEN}`,
    //     },
    //   })
    //   .then((response) => {
    //     this.shopGuideList = response.data;
    //     this.isLoading = false;
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //   });
  },
};
</script>